import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router';
import Profile, { ProfileVariant } from 'core/components/profile';
import {
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  MenuItem,
} from '@mui/material';
import p from 'translation';

interface Props {
  variant?: ProfileVariant;
  onClick?: () => void;
}

export default function NavigationProfileMenu({
  variant,
  onClick,
}: Props): JSX.Element {
  const history = useHistory();
  const [open, setOpen] = useState<boolean>(false);
  const ref = useRef<HTMLButtonElement | null>(null);

  return (
    <>
      <Profile
        ref={ref}
        aria-haspopup='true'
        aria-controls={open ? 'menu-list-grow' : undefined}
        onClick={() => setOpen(!open)}
        variant={variant}
      />
      <Popper
        style={{ zIndex: 13000 }}
        open={open}
        anchorEl={ref.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MenuList autoFocusItem={open} id='menu-list-grow'>
                  <MenuItem
                    onClick={() => {
                      setOpen(false);
                      history.push('/app/manage/profile/~/');
                      if (typeof onClick === 'function') {
                        onClick();
                      }
                    }}
                  >
                    {p.t('common.profile')}
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setOpen(false);
                      history.push('/logout');
                      if (typeof onClick === 'function') {
                        onClick();
                      }
                    }}
                  >
                    {p.t('logout.log-out')}
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
